import { render, staticRenderFns } from "./client-list-table.vue?vue&type=template&id=47314369&scoped=true&"
import script from "./client-list-table.vue?vue&type=script&lang=js&"
export * from "./client-list-table.vue?vue&type=script&lang=js&"
import style0 from "./client-list-table.vue?vue&type=style&index=0&id=47314369&lang=scss&scoped=true&"
import style1 from "./client-list-table.vue?vue&type=style&index=1&id=47314369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47314369",
  null
  
)

export default component.exports
import {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn,QTooltip,QToggle,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInnerLoading,QSpinnerIos,QInput,QIcon,QTr,QTh,QTd,QBtn,QTooltip,QToggle,QImg})
